import { runClientComponent } from '../../_common/client/client-component-runner';
import { DimensionSelectionComponent } from './dimension-selection.component';

runClientComponent({ DimensionSelectionComponent });
